import { ReactNode } from "react";

import { Content } from "./components";
import { AccountCreationContextProvider } from "./hooks";

export const AccountCreation = ({
    identityCobranding,
    templateId,
    ...props
}: {
    identityCobranding?: string;
    templateId?: string;
    Error?: ReactNode;
    Input?: ReactNode;
    Login?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Submit?: ReactNode;
}) => (
    <AccountCreationContextProvider
        identityCobranding={identityCobranding}
        templateId={templateId}
    >
        <Content {...props} />
    </AccountCreationContextProvider>
);
